import * as React from 'react';
import { identity } from 'lodash';
import { connect } from 'react-redux';

import { AppState } from 'src/store';
import { wrappedDispatch, WrappedDispatch } from 'src/utils/Redux/Dispatch';
import { AddBreadcrumbPayload, addCrumb, removeCrumbById, resetAllCrumbs } from 'src/state/breadcrumbs/Bread.slice';
import { removeLastCrumb, resetCrumbsByKey } from 'src/state/breadcrumbs/Bread.slice';

export interface InjectedProps<ParentProps> {
  parentProps: ParentProps;
  addCrumb(payload: AddBreadcrumbPayload): void;
  removeCrumbById(path: string): void;
  removeLastCrumb(): void;
  resetAllCrumbs(): void;
  resetCrumbsByKey(key: string): void;
}

export interface WithBreadCrumbProps
  extends Pick<
    InjectedProps<unknown>,
    'addCrumb' | 'removeCrumbById' | 'removeLastCrumb' | 'resetAllCrumbs' | 'resetCrumbsByKey'
  > {}

export interface Nameable {
  displayName?: string;
  name?: string;
}

function mergeProps<P>(_state: AppState, wrapped: WrappedDispatch, parentProps: P): InjectedProps<P> {
  return {
    parentProps,
    addCrumb: (payload) => wrapped.dispatch(addCrumb(payload)),
    removeCrumbById: (path) => wrapped.dispatch(removeCrumbById(path)),
    removeLastCrumb: () => wrapped.dispatch(removeLastCrumb()),
    resetAllCrumbs: () => wrapped.dispatch(resetAllCrumbs()),
    resetCrumbsByKey: (key) => wrapped.dispatch(resetCrumbsByKey(key)),
  };
}

export function makeBreadcrumbSensitive<P>(WrappedComponent: React.ComponentType<P>) {
  class BreadcrumbSensitive extends React.Component<InjectedProps<P>> {
    displayName = 'BreadcrumbSensitive';
    constructor(props: InjectedProps<P>) {
      super(props);
    }

    render() {
      return (
        <WrappedComponent
          addCrumb={this.props.addCrumb}
          removeCrumbById={this.props.removeCrumbById}
          removeLastCrumb={this.props.removeLastCrumb}
          resetCrumbsByKey={this.props.resetCrumbsByKey}
          resetAllCrumbs={this.props.resetAllCrumbs}
          {...this.props.parentProps}
        />
      );
    }
  }

  return connect<AppState, WrappedDispatch, P, InjectedProps<P>>(
    identity,
    wrappedDispatch,
    mergeProps,
  )(BreadcrumbSensitive);
}
